{
  "dismiss": "Скасувати"
}
